import { jsxs, jsx } from "../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import { theme } from "../../foundations/theme.es.js";
import CssBaseline from "../../../node_modules/@mui/material/CssBaseline/CssBaseline.es.js";
import ThemeProvider$1 from "../../../node_modules/@mui/material/styles/ThemeProvider.es.js";
function ThemeProvider({
  children,
  theme: theme$1 = theme,
  inlcudeCssBaseline = true
}) {
  if (inlcudeCssBaseline) {
    return /* @__PURE__ */ jsxs(ThemeProvider$1, { theme: theme$1, children: [
      /* @__PURE__ */ jsx(CssBaseline, {}),
      children
    ] });
  }
  return /* @__PURE__ */ jsx(ThemeProvider$1, { theme: theme$1, children });
}
export {
  ThemeProvider
};
//# sourceMappingURL=theme-provider.es.js.map
